module.exports = __webpack_public_path__ + "img/material_scan_bg.2e23d7ee.png";